import profile from "../images/image-amy.webp";

const About = () => {
	return (
		<div className='w-full md:h-364 xl:h-445 mt-100 md:mt-120 xl:mt-136 relative flex flex-col md:flex-row items-center md:justify-end xl:justify-between'>
			<img
				src={profile}
				alt='profile'
				className='w-300 md:w-364 xl:w-445 md:absolute xl:relative md:-left-20 xl:left-0'
			/>

			<div className='md:w-339 xl:w-540 md:h-364 xl:h-306 flex flex-col items-center md:items-start'>
				<h2 className='mt-10 md:mt-0 font-bold text-26 md:text-32 xl:text-40 leading-33 md:leading-40 xl:leading-50 text-center md:text-left'>
					I’m Amy, and I’d love to work on your next project
				</h2>
				<p className='mt-6 xl:mt-34 font-medium md:text-18 text-medium_brown leading-24 md:leading-28 text-center md:text-left'>
					I love working with others to create beautiful design solutions. I’ve designed everything
					from brand illustrations to complete mobile apps. I’m also handy with a camera!
				</p>
				<button className='w-176 h-44 md:w-228 md:h-56 mt-6 xl:mt-8 flex items-center justify-center bg-light_red hover:bg-summer_yellow rounded-full'>
					<p className='font-bold text-14 md:text-16 leading-28 text-light_cream'>
						Free Consultation
					</p>
				</button>
			</div>
		</div>
	);
};

export default About;
